import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import * as actionTypes from './actionTypes';
import {notify, localStorageFunc} from '../../helpers/utility';

export const agentDisconnectStart = () => {
  return {
    type: actionTypes.AGENT_DISCONNECT_START,
  };
};

export const agentDisconnectFail = (error) => {
  return {
    type: actionTypes.AGENT_DISCONNECT_FAIL,
    error: error,
  };
};

export const agentDisconnectSuccess = (agentId, status) => {
  return {
    type: actionTypes.AGENT_DISCONNECT_SUCCESS,
    status: status
  };
};
export const agentDisconnectReset = () => {
  return {
    type: actionTypes.AGENT_DISCONNECT_RESET,
  };
};

export const agentDisconnect = (agentId,isFeedback,callStatus,nextAction,actionType,phType,comment="",category="",disposition="",nextCallTime="", auto_wrapped="") => {
 // let comment ="";
  return (dispatch) => {
    dispatch(agentDisconnectStart());
      ctiRequest['CTI_DISCONNECT'].agent_id = agentId;
      ctiRequest['CTI_DISCONNECT'].isFeedback = isFeedback;
      ctiRequest['CTI_DISCONNECT'].dialer_disp = callStatus;
      ctiRequest['CTI_DISCONNECT'].next_action = nextAction;
      ctiRequest['CTI_DISCONNECT'].ph_type = phType;
      ctiRequest['CTI_DISCONNECT'].comment = comment;
      ctiRequest['CTI_DISCONNECT'].category = category;
      ctiRequest['CTI_DISCONNECT'].disposition = disposition;
      ctiRequest['CTI_DISCONNECT'].auto_wrapped = auto_wrapped;
      ctiRequest['CTI_DISCONNECT'].next_call_time = nextCallTime;
      window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
      ctiRequest['CTI_DISCONNECT'].ip = window.clientIP;
      actionType = 'CTI_DISCONNECT';
    axios
      .post('/', ctiRequest[actionType])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
           dispatch(agentDisconnectSuccess(agentId, result.data.response.status));
          localStorageFunc.erase("initialLeadId");
        } else {
          notify('Disconnect Error: ' + result.data.response.reason, 'agent-disconnect');
          dispatch(agentDisconnectFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Disconnect Error', 'agent-disconnect');
        dispatch(agentDisconnectFail(err));
      });
  };
};


export const agentTelDisconnectStart = () => {
  return {
    type: actionTypes.AGENT_TEL_DISCONNECT_START,
  };
};

export const agentTelDisconnectFail = (error) => {
  return {
    type: actionTypes.AGENT_TEL_DISCONNECT_FAIL,
    error: error,
  };
};

export const agentTelDisconnectSuccess = (agentId) => {
  return {
    type: actionTypes.AGENT_TEL_DISCONNECT_SUCCESS,
  };
};


export const agentTelDisconnect = (agentId,isFeedback,actionType) => {
 // let comment ="";
  return (dispatch) => {
    dispatch(agentTelDisconnectStart());
      ctiRequest['CTI_DISCONNECT_TEL'].agent_id = agentId;
      ctiRequest['CTI_DISCONNECT_TEL'].isFeedback = isFeedback;
      window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
      ctiRequest['CTI_DISCONNECT_TEL'].ip = window.clientIP;
      actionType = 'CTI_DISCONNECT_TEL';
    
    axios
      .post('/', ctiRequest[actionType])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
           dispatch(agentTelDisconnectSuccess(agentId));
          localStorageFunc.erase("initialLeadId");
        } else {
          notify('Disconnect Tel Error: ' + result.data.response.reason, 'agent-disconnect');
          dispatch(agentTelDisconnectFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Disconnect Tel Error', 'agent-disconnect');
        dispatch(agentTelDisconnectFail(err));
      });
  };
};